import update from 'immutability-helper';

import * as actionTypes from '../actions/actionTypes';

const initialState = {
  loggedIn: false,
  redirectFromLogIn: true,
  userId: null,
  isLoading: false,
  isLoaded: false,
  error: false,
  errorCode: null,
  userName: null,
  userGrade: null,
  userSchoolName: null,
  showErrorMsg: false,
};

const loginStudentStart = (state) => {
  return update(state, {
    error: { $set: null },
    isLoaded: { $set: false },
    isLoading: { $set: true },
    showErrorMsg: { $set: false },
  });
};

const loginStudentSuccess = (state, action) => {
  console.log(action);
  const { userId, grade: userGrade, userName, schoolName } = action;
  return update(state, {
    userId: { $set: userId },
    userGrade: { $set: userGrade },
    userName: { $set: userName },
    userSchoolName: { $set: schoolName },
    isLoaded: { $set: true },
    isLoading: { $set: false },
    loggedIn: { $set: true },
    redirectFromLogIn: { $set: true },
    showErrorMsg: { $set: false },
  });
};

const loginStudentFail = (state, action) => {
  const message  = action.error.response?.data?.message || 'Invalid invite code.';
  return update(state, {
    error: { $set: message },
    errorCode: { $set:  action.error.response?.data?.status || null },
    isLoading: { $set: false },
    showErrorMsg: { $set: true },
  });
};

const studentAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_STUDENT_START:
      return loginStudentStart(state, action);
    case actionTypes.LOGIN_STUDENT_SUCCESS:
      return loginStudentSuccess(state, action);
    case actionTypes.LOGIN_STUDENT_FAIL:
      return loginStudentFail(state, action);
    case actionTypes.RESET_APP:
      return initialState;
    default:
      return state;
  }
};

export default studentAuthReducer;
